export enum ErrorsKeyPasswordEnum {
  minLength = 'minlength',
  upperCaseLetter = 'upperCaseLetter',
  lowerCaseLetter = 'lowerCaseLetter',
  symbols = 'symbols',
  digits = 'digits',
  mustMatch = 'mustMatch'
}
